var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analytics-chart"},[_c('TheBox',{attrs:{"loading":_vm.analyticsGetLoading}},[_c('AnalyticsVisual')],1),_c('TheBox',{attrs:{"loading":_vm.analyticsGetLoading}},[_c('AnalyticsInfo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }